import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';

import { select, Store } from '@ngrx/store';

import { has } from 'lodash-es';
import { Observable } from 'rxjs';

import * as fromDataProviderActions from '../../../store/actions/data-provider.actions';
import * as fromDataPortalSelectors from '../../../store/selectors/data-portal.selectors';
import * as fromDataProviderSelectors from '../../../store/selectors/data-provider.selectors';
import { GenericComponent } from '../../components/generic/generic.component';
import { CustomValidators } from '../../validators/custom-validators';

interface ChangePasswordFormGroup {
  confirmPassword: FormControl<string | null>;
  oldPassword: FormControl<string | null>;
  password: FormControl<string | null>;
}

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'red-change-password',
  standalone: false,
  templateUrl: './change-password.page.html'
})
export class ChangePasswordPageComponent extends GenericComponent {
  private activatedRoute = inject(ActivatedRoute);
  private store = inject(Store);
  private changeDetectorRef = inject(ChangeDetectorRef);

  isOnboardingFlow = true;
  isPasswordExpired = true;

  dataPortalName$: Observable<string | null>;

  form: FormGroup<ChangePasswordFormGroup> = new FormGroup<ChangePasswordFormGroup>(
    {
      confirmPassword: new FormControl<string>('', Validators.required),
      oldPassword: new FormControl<string>('', Validators.required),
      password: new FormControl<string>('', Validators.required)
    },
    {
      validators: [CustomValidators.confirmPassword()]
    }
  );

  constructor() {
    super();
    this.isOnboardingFlow = !!this.activatedRoute.snapshot.data['isOnboardingFlow'];
    if (has(this.activatedRoute.snapshot.data, 'isPasswordExpired')) {
      this.isPasswordExpired = !!this.activatedRoute.snapshot.data['isPasswordExpired'];
    }
    this.dataPortalName$ = this.store.pipe(select(fromDataPortalSelectors.selectName));
  }

  ionViewDidEnter() {
    this.addUniqueSubscription(
      'selectDataProviderCredentials',
      this.store
        .pipe(select(fromDataProviderSelectors.selectDataProviderCredentials))
        .subscribe((dataProviderCredentials) => {
          this.form.patchValue({
            oldPassword: dataProviderCredentials.password ? atob(dataProviderCredentials.password) : null
          });
          this.form.markAsPristine();
          this.form.updateValueAndValidity();
          this.changeDetectorRef.detectChanges();
        })
    );
  }

  onSubmit() {
    this.store.dispatch(
      fromDataProviderActions.changePassword({
        payload: {
          isOnboardingFlow: this.isOnboardingFlow,
          newPassword: this.form.get('password')?.value ?? null,
          oldPassword: this.form.get('oldPassword')?.value ?? null
        }
      })
    );
  }
}
